// const averageWorker = new Worker('./averageWorker.js', { type: 'module' });
const qtrackWorker = new Worker('./qtrackWorker.js', { type: 'module' });

export default {
    // averageWorker,
    qtrackWorker
}